import { toast } from "sonner";
import { PageHeader, SectionCard } from "../components/common";
import { MovementForm } from "../components/MovementForm";
import { MovementTable } from "../components/MovementTable";
import { useApi } from "../hooks/useApi";
import { useAuth } from "../context/AuthContext";
import { useDepot } from "../context/DepotContext";
import { api, formatApiError, money, todayStr, TZ } from "../lib/api";

const CONFIG = {
  stock_in: {
    title: "Stock In", subtitle: "Receive goods from suppliers. Stock rises instantly and the purchase is logged as cash out.",
    party: "Supplier", priceLabel: "Unit cost", priceKey: "cost_price", submit: "Receive stock", testid: "stock-in",
  },
  stock_out: {
    title: "Stock Out · Sales", subtitle: "Record a sale. Stock is deducted and the amount is logged as cash in automatically.",
    party: "Customer", priceLabel: "Unit price", priceKey: "sell_price", submit: "Record sale", testid: "stock-out",
  },
};

export default function StockMovementPage({ type }) {
  const cfg = CONFIG[type];
  const { isAdmin } = useAuth();
  const { depotParam, scopeLabel } = useDepot();
  const products = useApi("/products", { depot_id: depotParam });
  const moves = useApi("/movements", { type, depot_id: depotParam, date: todayStr(), tz: TZ });
  const refresh = () => { products.reload(); moves.reload(); };
  const total = (moves.data || []).reduce((s, m) => s + m.total, 0);

  const voidMove = async (id) => {
    try {
      await api.delete(`/movements/${id}`);
      toast.success("Entry voided and stock reversed");
      refresh();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div className="space-y-6">
      <PageHeader eyebrow={scopeLabel} title={cfg.title} subtitle={cfg.subtitle} />
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6">
        <SectionCard title="New entry" className="xl:col-span-5 self-start">
          <MovementForm type={type} cfg={cfg} products={products.data || []} onDone={refresh} />
        </SectionCard>
        <SectionCard title="Today's entries" className="xl:col-span-7"
          right={<span className="font-mono text-sm text-slate-300" data-testid={`${cfg.testid}-today-total`}>{money(total)}</span>}>
          <MovementTable rows={moves.data} onVoid={isAdmin ? voidMove : null} testid={`${cfg.testid}-table`} />
        </SectionCard>
      </div>
    </div>
  );
}
